module.exports = __webpack_public_path__ + "static/bio-sam-pas-i-opet-sam-0dc352cd8667c56207f5fba4cc5f0913.png";